module.exports = __webpack_public_path__ + "clarify.2K8cAD2W.svg";